<template>
  <div v-if="doNotHaveAppointmentData">
    <div class="px-5">
      <h3 class="grey--text pt-10 pb-5">
        {{ $t('transfer.details.payments.label') }}
      </h3>

      <v-card outlined>
        <PaymentsTable :payments="payments" />
      </v-card>
    </div>
  </div>
</template>

<script>
import PaymentsTable from './components/PaymentsTable'

export default {
  name: 'TransferPayments',

  components: {
    PaymentsTable,
  },

  props: {
    transfer: {
      type: Object,
      required: true,
    },
  },

  computed: {
    doNotHaveAppointmentData() {
      return this.transfer.appointment === null
    },

    payments() {
      return this.transfer?.payments
    },
  },
}
</script>
